import { copy } from "shared/assets";
import { IUserPermissions } from "shared/utils";
import { VENUE_PATHS } from "Venues/router";
import { IActionDropdownItem } from "shared/components";
import { SuggestEditFormType } from "Venues/components";
import { VenueRouteParams } from "../hooks/useVenueRoute";

const { actions: actionsCopy } = copy;

export const getEquipmentBlockActions = ({
  userPermissions,
  venueId,
  stageId,
  categorySlug,
  openSuggestStageEditModal,
  pushRoute,
}: {
  userPermissions: IUserPermissions;
  venueId: string;
  stageId: string;
  categorySlug: string;
  openSuggestStageEditModal: (props: {
    type: SuggestEditFormType;
    categorySlug: string;
    stageId: string;
  }) => void;
  pushRoute: (path: string, options?: VenueRouteParams) => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];

  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: () =>
        pushRoute(VENUE_PATHS.EDIT_STAGE_EQUIPMENT, {
          venueId,
          stageId,
          params: { categorySlug },
        }),
    });
  }

  if (actions.length !== 0) {
    return actions;
  }
  return [
    {
      label: actionsCopy.suggestEdit,
      handleClick: () =>
        openSuggestStageEditModal({
          type: "StageEquipmentCategory",
          categorySlug,
          stageId,
        }),
      dataTestId: "suggest_edit",
    },
  ];
};
